const LargeGreenSuccessIcon = () => {
  return (
    <div className="w-[80px] h-[80px] flex items-center justify-center mx-auto mt-6 mb-6 rounded-full bg-[#0ba360]">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth="6"
        stroke="currentColor"
        className="size-12 text-white"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m4.5 12.75 6 6 9-13.5"
        />
      </svg>
    </div>
  );
};

export default LargeGreenSuccessIcon;
